// extracted by mini-css-extract-plugin
module.exports = {"logo":"authnavbar_logo__37P6e"};